import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card", "table", "tableContainer", "tableTitle"]
  static values = { titles: Object }

  connect() {
    this.activeFilter = "all"
    this.updateView()
  }

  selectAll() {
    this.activeFilter = "all"
    this.updateView()
  }

  select(event) {
    const filter = event.currentTarget.dataset.filter

    // Toggle: clicking the active card goes back to "all"
    if (this.activeFilter === filter) {
      this.activeFilter = "all"
    } else {
      this.activeFilter = filter
    }
    this.updateView()
  }

  updateView() {
    // Update card styles
    this.cardTargets.forEach(card => {
      const filter = card.dataset.filter
      const isActive = filter === this.activeFilter

      if (filter === "all") {
        // Conversion rate card has special styling
        card.classList.toggle("ring-2", isActive)
        card.classList.toggle("ring-amber-500", isActive)
      } else {
        card.classList.toggle("ring-2", isActive)
        card.classList.toggle("ring-primary", isActive)
        card.classList.toggle("border-base-300", !isActive)
      }
    })

    // Show the matching table, hide others
    this.tableTargets.forEach(table => {
      const type = table.dataset.tableType
      table.classList.toggle("hidden", type !== this.activeFilter)
    })

    // Update title
    if (this.hasTableTitleTarget) {
      this.tableTitleTarget.textContent = this.titlesValue[this.activeFilter] || "Engagement Activity"
    }
  }
}
